"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDateInput = exports.getDate = exports.formatTerm = exports.decomposeDate = exports.GMT_TIME_ZONE = void 0;
var _types = require("../types");
const STARTING_TIME = 'T00:00';
const INVALID_DATE = 'Invalid Date';
const DATE_INPUT_REGEX = /^\d{4}-(0[1-9]|1[0-2])-([0-2][0-9]|3[01])$/;
const isDateInput = term => DATE_INPUT_REGEX.test(term);
exports.isDateInput = isDateInput;
const padNumber = number => {
  return `${number}`.padStart(2, '0');
};
const getGMTTimeZone = () => {
  const offset = new Date().getTimezoneOffset();
  const isNegativeTimezone = offset > 0; // yes, ">"
  const sign = isNegativeTimezone ? '-' : '+';
  const hours = Math.abs(Math.floor(offset / 60));
  const minutes = Math.abs(offset % 60);
  return `GMT${sign}${padNumber(hours)}:${padNumber(minutes)}`;
};
const GMT_TIME_ZONE = exports.GMT_TIME_ZONE = getGMTTimeZone();
const getDate = term => {
  const date = new Date(`${term}${STARTING_TIME}`);
  if (date.toString() === INVALID_DATE) {
    // do a new attempt to force a valid date without adding time
    const newDate = new Date(term);
    if (newDate.toString() === INVALID_DATE) {
      return null;
    }
    return newDate;
  }
  return date;
};
exports.getDate = getDate;
const formatTerm = (dataType, term) => {
  if (dataType === _types.FacetsCustomFieldType.Date) {
    var _global$navigator;
    const date = getDate(term);
    if (!date) {
      return INVALID_DATE;
    }
    const navigatorLanguage = (_global$navigator = global.navigator) === null || _global$navigator === void 0 || (_global$navigator = _global$navigator.languages) === null || _global$navigator === void 0 ? void 0 : _global$navigator[0];
    return date.toLocaleDateString(navigatorLanguage);
  }
  return term;
};
exports.formatTerm = formatTerm;
const decomposeDate = date => {
  const newDate = new Date(date);
  if (newDate.toString() === INVALID_DATE) {
    return null;
  }
  if (isDateInput(date)) {
    return [newDate.getUTCFullYear(), newDate.getUTCMonth() + 1, newDate.getUTCDate()].map(padNumber).join('-');
  }
  return [newDate.getFullYear(), newDate.getMonth() + 1, newDate.getDate()].map(padNumber).join('-');
};
exports.decomposeDate = decomposeDate;
//# sourceMappingURL=date.js.map